import React, { useState } from "react";
import { Mail, Phone, MapPin, Github, Linkedin, Copy, Check, ArrowUpRight, Send } from "lucide-react";
import "./Contact.css";

const Contact = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText("premgore063@gmail.com");
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <section id="contact" className="section contact-section">
      <div className="container">
        
        {/* SECTION HEADER */}
        <div className="section-header center">
          <div className="eyebrow">08 / Connect Directly</div>
          <h2 className="section-title">
            Let's Build Something <em>Remarkable</em>
          </h2>
          <p className="section-subtitle">
            Open for full-time software engineering roles, scalable backend architecture challenges, and high-impact software projects.
          </p>
        </div>

        {/* CONTACT CARDS GRID */}
        <div className="contact-main-grid">
          
          {/* PRIMARY EMAIL HERO CARD */}
          <div className="contact-hero-card">
            <div className="contact-icon-bubble">
              <Mail size={24} className="hero-mail-icon" />
            </div>
            
            <span className="contact-card-eyebrow">Direct Inquiries</span>
            <h3 className="contact-hero-headline">premgore063@gmail.com</h3>
            <p className="contact-hero-text">
              Whether you are hiring for a backend/full-stack engineering position, architecting a new business platform, or discussing system design, feel free to reach out.
            </p>

            <div className="contact-hero-actions">
              <a
                href="mailto:premgore063@gmail.com"
                className="btn btn-accent contact-send-btn"
              >
                <Send size={16} />
                <span>Send Email</span>
              </a>

              <button
                onClick={handleCopyEmail}
                className="btn btn-outline copy-email-btn"
              >
                {copied ? <Check size={16} className="text-green" /> : <Copy size={16} />}
                <span>{copied ? "Copied to Clipboard!" : "Copy Email"}</span>
              </button>
            </div>
          </div>

          {/* SECONDARY CHANNELS COLUMN */}
          <div className="contact-channels-column">
            
            {/* PHONE CARD */}
            <a href="tel:+917666760842" className="channel-card">
              <div className="channel-icon-box">
                <Phone size={18} />
              </div>
              <div className="channel-info">
                <span className="channel-label">Direct Phone / WhatsApp</span>
                <span className="channel-value">+91 76667 60842</span>
              </div>
              <ArrowUpRight size={16} className="channel-arrow" />
            </a>

            {/* GITHUB CARD */}
            <a
              href="https://github.com/premgore"
              target="_blank"
              rel="noopener noreferrer"
              className="channel-card"
            >
              <div className="channel-icon-box">
                <Github size={18} />
              </div>
              <div className="channel-info">
                <span className="channel-label">GitHub Profile</span>
                <span className="channel-value">github.com/premgore</span>
              </div>
              <ArrowUpRight size={16} className="channel-arrow" />
            </a>

            {/* LINKEDIN CARD */}
            <a
              href="https://www.linkedin.com/in/prem-gore-284171417"
              target="_blank"
              rel="noopener noreferrer"
              className="channel-card"
            >
              <div className="channel-icon-box">
                <Linkedin size={18} />
              </div>
              <div className="channel-info">
                <span className="channel-label">LinkedIn Profile</span>
                <span className="channel-value">linkedin.com/in/prem-gore-284171417</span>
              </div>
              <ArrowUpRight size={16} className="channel-arrow" />
            </a>

            {/* LOCATION CARD */}
            <div className="channel-card location-static-card">
              <div className="channel-icon-box">
                <MapPin size={18} />
              </div>
              <div className="channel-info">
                <span className="channel-label">Location</span>
                <span className="channel-value">Shirdi, Maharashtra, India</span>
              </div>
              <span className="badge badge-neutral">IST (UTC+5:30)</span>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default Contact;